let MessagePreprocessor = {
	smileRegex: '',
	smileMap: {},
	smilies: [
		[[':hooray:'], 'D83CDF89.png'],
		[[':thinking:'], 'D83EDD14.png'],
		[[':scope:'], 'D83DDD2E.png'],

		[[':idea:'], 'idea.gif'],
		[[':lol:'], 'lol.gif'],
		[[':mrgreen:'], 'mrgreen.gif'],
		[[':roll:'], 'rolleyes.gif'],
		[[':like:'], 'like.png'],
		[[':!:'], 'exclaim.gif'],
		[[':?:'], 'question.gif'],

		[['<3'], 'heart.png'],
		[['=>'], 'arrow.gif'],
		[['<='], 'rarrow.gif'],
		[[':?', ':-?'], 'confused.gif'],
		[['8)', '8-)'], 'cool.gif'],
		[[':\'('], 'cry.gif'],
		[['O_O', 'O_o', 'o_O'], 'eek.gif'],
		[['>:(', '>:-('], 'evil.gif'],
//		[[''], 'frown.gif'],
		[[':|', ':-|'], 'neutral.gif'],
		[[':p', ':P', ':-p', ':-P'], 'razz.gif'],
		[[':$', ':-$'], 'redface.gif'],
		[[':(', ':-(', '=('], 'sad.gif'],
		[[':)', ':-)', '=)'], 'smile.gif'],
		[[':O', ':o', ':-O', ':-o'], 'surprised.gif'],
		[['>:D', '>:-D'], 'twisted.gif'],
		[[':D', ':-D'], 'biggrin.gif'],
		[[';)', ';-)'], 'wink.gif'],
		[['D:'], 'mad.gif'],
	],

	init(){
		let mp = {};
		let codes = [];
		for (let i in this.smilies){
			let s = this.smilies[i];
			for (let j in s[0]){
				let smile = s[0][j];
				mp[smile] = s[1];
				codes.push(smile);
			}
		}

		this.smileCodes = codes;
		this.smileRegex = new RegExp('(' + codes.map(RegExp.escape).join('|') + ')', 'g');
		this.smileMap = mp;
	},

	process(str){
		let me = this;
		let obj = {
			_msg: [{
				type: 'text',
				text: str,
			}],

			parseRegex: function(regex, cbk){
				this._msg = me.parseRegex(this._msg, regex, cbk);
				return obj;
			},

			parseSmilies: function(){
				this._msg = me.parseSmilies(this._msg);
				return obj;
			},

			resultObject: function(){
				return this._msg;
			},

			result(){
				return me.translateMessageObjectToString(this._msg);
			},
		};

		return obj;
	},

	parseRegex(obj, regex, cbk){
		if (!regex.global){
			throw 'Need global flag for regex';
		}

		let res = [];
		for (let oi in obj){
			let o = obj[oi];
			if (o.type == 'text'){
				let mat;
				let lastIdx = 0;
				while (mat = regex.exec(o.text)){
					if (lastIdx != mat.index){
						let pref = o.text.substr(lastIdx, mat.index - lastIdx);
						res.push({
							type: 'text',
							text: pref,
						});
					}

					let cres = cbk(mat);
					if (cres){
						res.push(cres);
					}

					lastIdx = regex.lastIndex;
				}

				if (lastIdx < o.text.length){
					let pref = o.text.substr(lastIdx);
					res.push({
						type: 'text',
						text: pref,
					});
				}
			} else {
				res.push(o);
			}
		}

		return res;
	},

	parseSmilies(obj){
		let me = this;
		return this.parseRegex(obj, this.smileRegex, function(el){
			return {
				type: 'smile',
				code: el[0],
				icon: me.smileMap[el[0]],
			};
		});
	},

	translateMessageObjectToString(objmsg){
		let $el = $('<span/>');
		let emsg = '';
		for (let i in objmsg){
			let obj = objmsg[i];
			switch (obj.type){
				case 'raw': emsg += obj.html; break;
				case 'text':
					$el.text(obj.text);
					emsg += $el.html();
					break;

				case 'url': emsg += '<a href="' + obj.url + '" target="_blank">' + obj.url + '</a>'; break;
				case 'room': emsg += obj.spaces + '<a href="#" class="chat-message-room-link" title="Подключиться к комнате">' + obj.room + '</a>'; break;
				case 'smile': emsg += '<img src="/res/smilies/' + obj.icon + '" alt="' + obj.code + '" title="' + obj.code + '">'; break;
				case 'mention':
					if (obj.user.user_id > 0){
						emsg += `<a href="/profile/${obj.user.user_id}" target="_blank" style="color: ${obj.user.color}">@${obj.user.name}</a>`;
					} else {
						emsg += `<span style="color: ${obj.user.color}">@${obj.user.name}</span>`;
					}
					break;

				case 'quote':
					let $q = $('<span class="quote"/>');
					$q.html(obj.html);
					$el.html('');
					$el.append($q);
					emsg += $el.html();
					break;

				case 'command':
					$el.text(obj.text);
					emsg += '<span style="color: ' + Chat.syscolor2 + ';">' + $el.html() + '</span>';
					break;
			}
		}

		return emsg;
	},

	preprocessMessageText(room, emsg){
		let me = this;
		let objmsg = MessagePreprocessor.process(emsg)
		.parseRegex(/^> (?:([\s\S]+?)(?:\n^$\n?)|([\s\S]+)$)/mg, function(el){
			let msg = (el[1] ? el[1] : '') + (el[2] ? el[2] : '');
			msg = msg.replace(/^> /mg, '');
			return {
				type: 'quote',
				html: me.preprocessMessageText(room, msg),
			};
		})
		.parseRegex(/https?:\/\/[^\s"']+/g, function(el){
			return {
				type: 'url',
				url: el[0],
			};
		})
		.parseRegex(/(^|\s)(#[^\s<>]+)/g, function(el){
			return {
				type: 'room',
				room: el[2],
				spaces: el[1],
			};
		});

		if (room && room.getMembers().length > 0){
			let logins = room.getMembers().map(x => RegExp.escape(x.name)).sort().reverse().join('|');
			let membersRegex = new RegExp('@(' + logins + ')', 'g');
			objmsg = objmsg.parseRegex(membersRegex, el => {
				return {
					type: 'mention',
					user: room.getMembers().find(x => x.name == el[1]),
				};
			});
		}

		objmsg = objmsg.parseSmilies()
		.parseRegex(/\n/g, function(el){
			return {
				type: 'raw',
				html: '<br>',
			};
		});


		return objmsg.result();
	},

	preprocessSysMessageText(room, emsg){
		let objmsg = MessagePreprocessor.process(emsg)
		.parseRegex(/https?:\/\/[^\s"']+/g, function(el){
			return {
				type: 'url',
				url: el[0],
			};
		})
		.parseRegex(/^\/.+$/gm, function(el){
			return {
				type: 'command',
				text: el[0],
			};
		})
		.parseRegex(/\n/g, function(el){
			return {
				type: 'raw',
				html: '<br>',
			};
		});

		return objmsg.result();
	},
};

module.exports = MessagePreprocessor;
